import axios from 'axios'
const CancelToken = axios.CancelToken
export default {
  name: 'dashboard',
  mounted () {
  },
  created () {
    this.$eventBus.$emit('$changeAppTitle', 'Dashboard')
    // this.$eventBus.$emit('$displayMainLoader', true)
    // setTimeout(() => {
    //   this.$eventBus.$emit('$displayMainLoader', false)
    // }, 2000)
    // this.$eventBus.$emit('$globalSnackbar', 'red', 'User created successfully')
  },
  data: function () {
    return {
      loading: false,
      isLastPage: false,
      page: 1,
      items: [{ id: 9, text: '9 Text Item 9' }, { id: 10, text: '10 Text Item 10' }],
      search: '',
      selected: [{ id: 9, text: '9 Text Item 9' }, { id: 10, text: '10 Text Item 10' }],
      hide_no_data: true,
      companyIds: '',
      companyIds2: '',
      errorData: {},
    }
  },
  watch: {
    search (val) {
      val && val !== this.selected && this.callRequestDebounced()
    }
  },
  methods: {
    routeOn: function () {
      this.$eventBus.$emit('$changeAppTitle', 'Dashboardd')
    },
    callRequestDebounced () {
      clearTimeout(this._callRequestDebounced)

      this._callRequestDebounced = setTimeout(() => {
        this.callRequest()
      }, 500)
    },
    focusOnAutoComplete () {
      this.callRequest()
    },
    callRequest () {
      this.loading = true
      console.log(this.requestCancel)
      if (this.requestCancel !== undefined) {
        this.requestCancel()
      }
      const headersOptions = {
        mainLoader: false,
        cancelToken: new CancelToken((c) => {
          this.requestCancel = c
        }),
      }
      this.$axios.post('web_getMachineData', { page: this.page, str: this.search }, headersOptions).then((res) => {
        this.items = [...this.items, ...res.data]
        this.loading = false
      }).catch((err) => {
        console.log(err)
      })
    },
    visibilityChanged (e) {
      if (e) {
        this.page++
        this.callRequest()
      }
    },
    emptyItems () {
    },
    clickEventM () {
      if (this.companyIds === '') {
        const error = {
          companyIds: 'Please select company id.'
        }
        this.errorData = error
      } else {
        this.errorData = {}
      }
    }
  },
}
